import {
  LayoutOptions,
  PrimaryBlockType,
  processLayoutOptions,
  MediaProp,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

export const layoutOptions = { ...LayoutOptions.BackgroundColor, ...{} };

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type EyecatcherType = {
  /** Place prop documentation here */
  tagline: string;
  header: string;
  description: string;
  images: MediaProp[];
} & PrimaryBlockType<LayoutProps>;
